
const GOOGLEMAPKEY = 'AIzaSyCLz2cTUf9oX-8YJySE_DhskzIZgIEADso';
const SERVERURL = 'https://api-dev.klearexpress.com/v1/events';

export {
  GOOGLEMAPKEY,
  SERVERURL
};
